"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Patient = void 0;
class Patient {
    constructor(props) {
        this._start_date = props?._start_date || "";
        this.address = props?.address || "";
        this.call = props?.call;
        this.accept = {
            date: "",
            terms_version: 0,
            privacy_version: 0,
        };
        this.corporate = props?.corporate || "";
        this.corporate_norm = props?.corporate_norm || "";
        this.country = props?.country || null;
        this.core_id = props?.core_id || props?.uid || props?.id;
        this.coverages = props?.coverages || [];
        this.cuit = props?.cuit || "";
        this.device = {
            messaging_token: props?.device?.messaging_token || null,
            permissions: {
                microphonePermission: props?.device?.permissions.microphonePermission || false,
                webcamPermission: props?.device?.permissions.webcamPermission || false,
            },
            info: {
                device: props?.device?.info.device || "",
                browser: props?.device?.info.browser || "",
                displayResolution: props?.device?.info.displayResolution || "",
                isPhone: props?.device?.info.isPhone || false,
                installed: props?.device?.info.installed || false,
                uma_version: props?.device?.info.uma_version || "",
            },
            peripherals: {
                audioInputDevices: [],
                audioOutputDevices: [],
                videoInputDevices: [],
            },
        };
        this.dob = props?.dob || "";
        this.dni = props?.dni || "";
        this.dt = props?.dt || null; // Legacy
        this.email = props?.email || "";
        this.firstname = props?.firstname || "";
        this.lastname = props?.lastname || "";
        this.fullname = props?.fullname || "";
        this.geohash = props?.geohash || "";
        this.group = props?.group || "";
        this.id = props?.id || props?.uid || props?.core_id;
        this.incidente_id = props?.incidente_id || "";
        this.lat = props?.lat || "";
        this.lon = props?.lon || "";
        this.login = props?.login || [];
        this.nationality = props?.nationality || "";
        this.referral = props?.referral || "";
        this.registerCompleated = props?.registerCompleated || false;
        this.sex = props?.sex || "F";
        this.street = props?.street || "";
        this.timestamps = props?.timestamps || {};
        this.uid = props?.uid || props?.id || props?.core_id;
        this.uma_creditos = props?.uma_creditos || 0;
        this.verified = props?.verified || false;
        this.ws = props?.ws || "";
        this.active_express_appointment = props?.active_express_appointment || false;
        this.chosenName = props?.chosenName || null;
        this.documentType = props?.documentType || null;
        this.path_dni = props?.path_dni || null;
        this.path_dni_back = props?.path_dni_back || null;
        this.profile_pic = props?.profile_pic || "";
        this.pronouns = props?.pronouns || null;
    }
}
exports.Patient = Patient;
